interface ToggleButtonProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  bgColor?: string;
  checkedBgColor?: string;
  circleColor?: string;
}

const ToggleButton = ({ checked, onChange, bgColor = 'bg-lawkitGray-300', checkedBgColor = 'bg-lawkitBlue-70', circleColor = 'bg-white' }: ToggleButtonProps) => {
  return (
    <button className={`w-11 h-6 p-0.5 flex ${checked ? checkedBgColor : bgColor} rounded-full`} onClick={() => onChange(!checked)}>
      <div className={`w-5 h-5 ${circleColor} rounded-full transition-all duration-300`} style={{ transform: checked ? 'translateX(100%)' : 'translateX(0)' }}></div>
    </button>
  );
};

export default ToggleButton;
